import { render, staticRenderFns } from "./LogoTopestates.vue?vue&type=template&id=95e3d582&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e3d582')) {
      api.createRecord('95e3d582', component.options)
    } else {
      api.reload('95e3d582', component.options)
    }
    module.hot.accept("./LogoTopestates.vue?vue&type=template&id=95e3d582&", function () {
      api.rerender('95e3d582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/svg/LogoTopestates.vue"
export default component.exports